import { useEffect, useContext, useState } from 'react'
import { useQuery } from 'react-query';
import { SessionContext } from '../../Components/Context/SessionContext';
import * as KeyNames from '../../api/KeyNames';
import * as Api from '../../api/Api';
import { useGetToken } from '../../Hooks/CustomHooks'
import { Loading } from '../../Components/Loading/Loading';
import { useHistory } from 'react-router-dom';

export default function Auth({ children, RenderError = () => <></> }) {
    /**
     * Si encuentra data en SESSION,  devuelve children.*
     * Si no, pregunta si hay token en localstorage, 
     *  Si hay token, llama al servidor, enviando el token, 
     *      Si data.succes setea session y devuelve children
     *      Si no, nulea session y devuelve children //debería traer data.success false si el token no existe en bd o venció.
     *  Si no hay token, nulea session y devuelve children
     * 
     */
    let token = useGetToken();
    const history = useHistory();
    const { session, setSession } = useContext(SessionContext);
    let { data, isLoading, isError } = useQuery(KeyNames.SessionData, async () => await Api.getUser(token),
        {
            retry: false,
            enabled: Boolean((token && !session?.sessionToken))
        });
    let tokeTemporal = data?.data?.sessionToken;
    let { data: dataRoleList, isLoading: dataIsLoading, isError: dataIsError } = useQuery([KeyNames.SessionData, "RoleListAfterLogin"],
        async () => await Api.getRoleList({ token: data.data.sessionToken }),
        {
            enabled: !!tokeTemporal,
        });

    let { data: dataGetAnioComparativo } = useQuery('GetComparativo',
        async () => await Api.GetAnioComparativo({ token: token }),
        {
            enabled: Boolean(!!tokeTemporal)
        }
    )

    const { data: dataInfoLocatario } = useQuery([KeyNames.SessionData, "getInfoLocatario"],
        async () => await Api.GetDataInfoLocatario(data.data.idUsuarioLocatario),
        {
            enabled: (data?.data?.role.id === "102" || data?.data?.role.id === "114") && data?.data?.idUsuarioLocatario !== 0,
        });

    const [dataRuc, setDataRuc] = useState(null);
    const [dataNroContrato, setDataNroContrato] = useState(null);

    useEffect(() => {
        if (dataRoleList && data && dataGetAnioComparativo) {
            if (dataRoleList.success && data.success && dataGetAnioComparativo.success) {
                data.data.sessionToken = token; //Parchesito 2do release
                //setSession(data.data);    //LOGIN REAL
                setSession({
                    ...data.data, "roleList": dataRoleList.data.table.map(({ name, id }) => {
                        return { id, name };
                    })
                });

                // if(data.data.role.id === "102" && data.data.idUsuarioLocatario !== 0) {
                //     Api.GetDataInfoLocatario(data.data.idUsuarioLocatario)
                //         .then(r => {
                //             setDataRuc(r.data.ruc);
                //             setDataNroContrato(r.data.nroContrato);
                //     });
                // }

                if ((data.data.role.id === "102" || data.data.role.id === "114") && data.data.idUsuarioLocatario !== 0 && dataInfoLocatario?.success) {
                    setDataRuc(dataInfoLocatario.data.ruc);
                    setDataNroContrato(dataInfoLocatario.data.nroContrato);
                }

                if (data.data.idUsuarioLocatario === 0 && (data.data.role.id === "102" || data.data.role.id === "114")) {
                    history.push('/locatario/seleccionar-contrato')
                }
                localStorage.setItem('anioComparativo', dataGetAnioComparativo.data.anioComparativo)
            } else {
                localStorage.clear()
                sessionStorage.clear()
                setSession(null)
                history.push('/auth/login')
            }
        }

    }, [dataRoleList, data, dataGetAnioComparativo, dataInfoLocatario]);


    useEffect(() => {
        if (dataRuc) {

            setSession({
                ...data.data,
                "ruc": dataRuc,
                "nroContrato": dataNroContrato,
                "roleList": dataRoleList.data.table.map(({ name, id }) => {
                    return { id, name };
                })
            });
        }
    }, [dataRuc, dataNroContrato])

    useEffect(() => {
        if (!token) {
            setSession(null);
        }
    }, [token, setSession])

    /* #region  LOGIN FALSO */
    // useEffect(() => {
    //     setSession(
    //         {
    //             "name": "Mall Aventura",
    //             "email": "mallaventura@mallaventura.com",
    //             "role": 4,
    //             "idUsuarioLocatario": 2142,
    //             "userState": true,
    //             "sessionToken": "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiRnJhbmsgQywiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJmY2V2YWxsb3NAdm94aXZhLmFpIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQ29vcmRpbmFjacOzbiBHZW5lcmFsIiwibmJmIjoxNjQ3ODc5OTM2LCJleHAiOjE2NDc5MjMxMzYsImlzcyI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0Mzg5IiwiYXVkIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzODkifQ.EvWZxAwva-veH4b6W1PcbuYoDYK9smm_OhsMMUAYqOU"
    //         }
    //     );
    // }, []);
    /* #endregion */


    /* #region LOGIN VERDADERO  */

    if (isLoading || dataIsLoading) return (<Loading />)
    if (isError || dataIsError) {
        localStorage.clear(KeyNames.SessionData);
        localStorage.clear(KeyNames.PathName);
        localStorage.clear()
        sessionStorage.clear()
        document.location.reload();
    }
    if (data) return (<>{children}</>)


    if (session?.sessionToken) return (<>{children}</>);
    if (!token) { return (<>{children}</>); }

    /* #endregion */

    // return (<>{children}</>); //comentar para que funcione el login original
}